<template>
  <div>
    <generic-tooltip v-if="showModal" @close="showModal = false">
      <h2 class="text-lg font-bold mb-4 text-blue-brand">Share this page</h2>
      <share-this-links
        :title="title"
        :url="url"
        :twitter="twitter"
        :linkedin="linkedin"
        :facebook="facebook"
        :email="email"
        :copyUrl="copyUrl"
      ></share-this-links>
    </generic-tooltip>
    <button type="button" class="border-2 p-3 my-2 border-blue-brand w-full align-middle font-primary font-extrabold text-12 md:text-14 text-center uppercase tracking-1/4 inline-block" @click.prevent="showModal = true">
      <svg-sprite href="icon-share" class="inline-block w-5 h-5 mr-2"></svg-sprite>
      <slot>Share this page</slot>
    </button>
  </div>
</template>

<script>
import GenericTooltip from './GenericTooltip.vue';

export default {
  components: { GenericTooltip },

  props: {
    title: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: window.location.href,
    },
    twitter: {
      type: Boolean,
      default: false,
    },
    facebook: {
      type: Boolean,
      default: true,
    },
    linkedin: {
      type: Boolean,
      default: true,
    },
    email: {
      type: Boolean,
      default: true,
    },
    copyUrl: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      showModal: false,
    };
  },

  methods: {
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>
